import React from 'react'
import _ from 'lodash'
import Header from '../Header'
import averageMonthlyCostByAge from '../../../../calculations/averageMonthlyCostByAge'
import Nav from './Nav'
import MonthlyChart from './MonthlyChart'

export default ({ form }) => (
  <>
    <Header value={_.meanBy(averageMonthlyCostByAge(form), 'value')}>
      Average monthly costs of raising a child:
    </Header>

    <Nav />
    <MonthlyChart form={form} />
  </>
)
